function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import dispatchEvent from './dispatchEvent';
import serializeEvent from './serializeEvent';
import reconcile from './reconcile';
import { version } from '../package.json';

var Component = /*#__PURE__*/function () {
  function Component(client, element) {
    var _this = this;

    _classCallCheck(this, Component);

    this._isShutdown = false;
    this.client = client;
    this.element = element;

    this._beforeConnect();

    var subscription = this.client.consumer.subscriptions.create({
      channel: 'Motion::Channel',
      version: version,
      state: this.element.getAttribute(this.client.stateAttribute)
    }, {
      connected: function connected() {
        if (_this._isShutdown) {
          subscription.unsubscribe();
          return;
        }

        _this._subscription = subscription;

        _this._connect();
      },
      rejected: function rejected() {
        return _this._connectFailed();
      },
      disconnected: function disconnected() {
        return _this._disconnect();
      },
      received: function received(newState) {
        return _this._render(newState);
      }
    });
  }

  _createClass(Component, [{
    key: "processMotion",
    value: function processMotion(name) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : event && event.currentTarget;

      if (!this._subscription) {
        this.client.log('Dropped motion', name, 'on', this.element);
        return false;
      }

      this.client.log('Processing motion', name, 'on', this.element);
      var extraDataForEvent = event && this.client.getExtraDataForEvent(event);

      this._subscription.perform('process_motion', {
        name: name,
        event: event && serializeEvent(event, extraDataForEvent, element)
      });

      return true;
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this._isShutdown = true;

      if (this._subscription) {
        this._subscription.unsubscribe();

        delete this._subscription;
      }

      this._disconnect();
    }
  }, {
    key: "_beforeConnect",
    value: function _beforeConnect() {
      this.client.log('Connecting component', this.element);
      dispatchEvent(this.element, 'motion:before-connect');
    }
  }, {
    key: "_connect",
    value: function _connect() {
      this.client.log('Component connected', this.element);
      dispatchEvent(this.element, 'motion:connect');
    }
  }, {
    key: "_connectFailed",
    value: function _connectFailed() {
      this.client.log('Failed to connect component', this.element);
      dispatchEvent(this.element, 'motion:connect-failed');
    }
  }, {
    key: "_disconnect",
    value: function _disconnect() {
      this.client.log('Component disconnected', this.element);
      dispatchEvent(this.element, 'motion:disconnect');
    }
  }, {
    key: "_render",
    value: function _render(newState) {
      dispatchEvent(this.element, 'motion:before-render');
      reconcile(this.element, newState, this.client.keyAttribute);
      this.client.log('Component rendered', this.element);
      dispatchEvent(this.element, 'motion:render');
    }
  }]);

  return Component;
}();

export { Component as default };